import { render, staticRenderFns } from "./RelatorioPedidoListFiltroModalItem.vue?vue&type=template&id=273253fa"
import script from "./RelatorioPedidoListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports